<template>
  <div class="info-container">
    <div class="info-box">
      <div v-if="!isActivity" class="info-avatar">
        <img class="img" :src="imgSrc || 'http://image.xinli001.com/images/avatar.jpg!80'" alt="壹心理-直播">
        <span>{{ title || '' }}</span>
      </div>
      <p :class="isActivity ? 'info-activity' : 'info-default'" class="info-subheading" v-html="subheading"></p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "InfoCon",
    props: {
      imgSrc: {
        type: String,
        default: 'http://image.xinli001.com/images/avatar.jpg!80'
      },
      title: {
        type: String,
        default: '标题'
      },
      subheading: {
        type: String,
        default: '副标题'
      },
      isActivity: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins.scss";

  .info-container {
    position: relative;
    width: 100%;
    height: 240px;

    background-image: linear-gradient(0deg, rgba(0,0,0,.3) 0%, rgba(0,0,0,0.00) 100%);

    .info-box {
      position: absolute;
      bottom: 16px;
      left: 16px;
      right: 16px;


      .info-avatar {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        span {
          padding-left: 20px;
          font-size: 30px;
          color: #fff;
          font-weight: bold;
          @include overLine(1)
        }
      }

      .info-activity {
        font-size: 30px;
        font-weight: bold;
      }

      .info-default {
        font-size: 24px;
      }

      .info-subheading {
        color: #fff;
        @include overLine(1)
      }
    }
  }
</style>
